import React from 'react';
import './FractionDisplay.css';

export default function FractionDisplay({ num, den, size = 'large', mixed = false }) {
  // Whole number (den === 1) or zero
  if (den === 1 || num === 0) {
    return (
      <span className={`fraction-display ${size}`}>
        <span className="frac-whole-only">{num}</span>
      </span>
    );
  }

  // Mixed fraction display
  if (mixed && Math.abs(num) >= den) {
    const absNum = Math.abs(num);
    const whole = Math.floor(absNum / den);
    const remainder = absNum % den;
    const sign = num < 0 ? '−' : '';

    if (remainder === 0) {
      return (
        <span className={`fraction-display ${size}`}>
          <span className="frac-whole-only">{sign}{whole}</span>
        </span>
      );
    }

    return (
      <span className={`fraction-display mixed ${size}`}>
        <span className="frac-whole">{sign}{whole}</span>
        <span className="frac-proper">
          <span className="frac-num">{remainder}</span>
          <span className="frac-bar" />
          <span className="frac-den">{den}</span>
        </span>
      </span>
    );
  }

  // Regular fraction
  return (
    <span className={`fraction-display ${size}`}>
      <span className="frac-num">{num}</span>
      <span className="frac-bar" />
      <span className="frac-den">{den}</span>
    </span>
  );
}
